module.exports = __webpack_public_path__ + "img/1.535820b0.png";